export default "__VITE_ASSET__BuRQ9tlA__"